import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {UploadContent} from "../api";

export class UploadsService extends RestService<UploadContent> {
    constructor(url) {
        if (!url) {
            super(REST_API_END_POINTS.UPLOADS)
        } else {
            super(url)
        }
    }

    upload_to_gsx() {
        return this.instance.get(`${this.url}upload_to_gsx/`)
    }
}
